import {
  FETCH_VEHICLES_DOCUMENTS_TYPES_DATA,
  FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS,
  FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE,
  DELETE_VEHICLES_DOCUMENTS_TYPE,
  DELETE_VEHICLES_DOCUMENTS_TYPE_SUCCESS,
  DELETE_VEHICLES_DOCUMENTS_TYPE_FAILURE,
} from "./actionTypes";

export const fetchVehiclesDocumentsTypesData = () => ({
  type: FETCH_VEHICLES_DOCUMENTS_TYPES_DATA,
});

export const fetchVehiclesDocumentsTypesSuccess = (data) => ({
  type: FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS,
  payload: data,
});

export const fetchVehiclesDocumentsTypesFailure = (error) => ({
  type: FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE,
  payload: error,
});

export const deleteVehiclesDocumentsType = (id) => ({
  type: DELETE_VEHICLES_DOCUMENTS_TYPE,
  payload: id,
});

export const deleteVehiclesDocumentsTypeSuccess = () => ({
  type: DELETE_VEHICLES_DOCUMENTS_TYPE_SUCCESS,
});

export const deleteVehiclesDocumentsTypeFailure = (error) => ({
  type: DELETE_VEHICLES_DOCUMENTS_TYPE_FAILURE,
  payload: error,
});
